import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const ITEM_CALCULATION_RESULT_SCHEMA = Object.freeze({
  ITEM_ID: '',
  TOTAL: 0,
  SUB_TOTAL: 0,
  TOTAL_TAX: 0,
  TOTAL_DISCOUNT: 0,
  TOTAL_WITHHOLDING: 0,
  TAXES: null,
});
const RECORD = generateSchema(ITEM_CALCULATION_RESULT_SCHEMA);
const KEYS: any = generateKeys(ITEM_CALCULATION_RESULT_SCHEMA);

export class ItemCalculationResult extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get itemId(): string {
    return this.get(KEYS.ITEM_ID);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }

  get subTotal(): number {
    return this.get(KEYS.SUB_TOTAL);
  }

  get totalTax(): number {
    return this.get(KEYS.TOTAL_TAX);
  }

  get totalDiscount(): number {
    return this.get(KEYS.TOTAL_DISCOUNT);
  }

  get total_withholding(): number {
    return this.get(KEYS.TOTAL_WITHHOLDING);
  }
}
